// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trialOffer_trialSection__\\+-uOC {
  background: #0D0E11;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  justify-content: center;
  font-family: "Noto Sans", sans-serif;
  margin-bottom: 0;
}

.trialOffer_trialOffer__ncrzj {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.trialOffer_trialDays__xY88B {
  color: var(--Text-0---Pure-white, #FFF);

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  font-family: "Noto Sans", sans-serif;
  letter-spacing: 0.6px;
  padding-bottom: 8px;
}

.trialOffer_freeBadge__MN21N {
  background: linear-gradient(90deg, rgba(19, 138, 38, 0.00) -0.35%, rgba(19, 138, 38, 0.50) 49.65%, rgba(19, 138, 38, 0.00) 99.65%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 3px 38px;
    text-transform: uppercase;
    color: var(--Text-0---Pure-white, #FFF);
    text-align: center;
    font-family: "Noto Sans", sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
    margin-bottom: 15px;
}

.trialOffer_trialText__DBd8N {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  line-height: 38px;
  font-family: "Noto Sans", sans-serif;
  letter-spacing: -0.5px;
}

.trialOffer_trialDetails__5HnzE {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.trialOffer_trialPrice__LCASB {
  font-size: 14px;
  font-weight: 400;
  color: #959595;
  line-height: 17px;
  font-family: "Noto Sans", sans-serif;
}

.trialOffer_trialRefund__77KJK {
  font-size: 14px;
  font-weight: 400;
  color: #1dae34;
  line-height: 17px;
  font-family: "Noto Sans", sans-serif;
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/TrialOffer/trialOffer.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,uCAAuC;;EAEvC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kIAAkI;EAClI,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;IACf,yBAAyB;IACzB,uCAAuC;IACvC,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oCAAoC;AACtC","sourcesContent":[".trialSection {\n  background: #0D0E11;\n  padding: 10px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Noto Sans\", sans-serif;\n  margin-bottom: 0;\n}\n\n.trialOffer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.trialDays {\n  color: var(--Text-0---Pure-white, #FFF);\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  font-family: \"Noto Sans\", sans-serif;\n  letter-spacing: 0.6px;\n  padding-bottom: 8px;\n}\n\n.freeBadge {\n  background: linear-gradient(90deg, rgba(19, 138, 38, 0.00) -0.35%, rgba(19, 138, 38, 0.50) 49.65%, rgba(19, 138, 38, 0.00) 99.65%);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 3px 38px;\n    text-transform: uppercase;\n    color: var(--Text-0---Pure-white, #FFF);\n    text-align: center;\n    font-family: \"Noto Sans\", sans-serif;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 38px;\n    margin-bottom: 15px;\n}\n\n.trialText {\n  font-size: 32px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 38px;\n  font-family: \"Noto Sans\", sans-serif;\n  letter-spacing: -0.5px;\n}\n\n.trialDetails {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.trialPrice {\n  font-size: 14px;\n  font-weight: 400;\n  color: #959595;\n  line-height: 17px;\n  font-family: \"Noto Sans\", sans-serif;\n}\n\n.trialRefund {\n  font-size: 14px;\n  font-weight: 400;\n  color: #1dae34;\n  line-height: 17px;\n  font-family: \"Noto Sans\", sans-serif;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trialSection": `trialOffer_trialSection__+-uOC`,
	"trialOffer": `trialOffer_trialOffer__ncrzj`,
	"trialDays": `trialOffer_trialDays__xY88B`,
	"freeBadge": `trialOffer_freeBadge__MN21N`,
	"trialText": `trialOffer_trialText__DBd8N`,
	"trialDetails": `trialOffer_trialDetails__5HnzE`,
	"trialPrice": `trialOffer_trialPrice__LCASB`,
	"trialRefund": `trialOffer_trialRefund__77KJK`
};
export default ___CSS_LOADER_EXPORT___;
